module.exports = __webpack_public_path__ + "static/media/restaurant-9.a70ffd6b.jpg";